/**
 * V17.520 (Phase 0c, brief 2026-10-26-001, F01 step 2): shown under the header while the
 * server cannot be reached and the app runs on the cached login (AuthContext `isOffline`).
 * Lao by default. "Retry" asks AuthProvider to re-check `/users/me` now; it also re-checks
 * by itself on the browser `online` event and every 30 s. No time is shown.
 */
import { useContext } from 'react';
import { WifiOff } from 'lucide-react';
import { AUTH_RETRY_EVENT, useAuth } from '../../contexts/AuthContext';
import { LanguageContext } from '../../contexts/LanguageContext';

const TEXT = {
  lo: { message: 'ບໍ່ມີສັນຍານອິນເຕີເນັດ — ຂໍ້ມູນອາດບໍ່ແມ່ນລ່າສຸດ', retry: 'ລອງໃໝ່' },
  en: { message: 'No connection — data may be out of date', retry: 'Retry' },
};

export default function OfflineBanner() {
  const { isOffline } = useAuth();
  const language = useContext(LanguageContext)?.language ?? 'lo';
  if (!isOffline) return null;
  const t = TEXT[language];
  return (
    <div
      role="status"
      data-testid="offline-banner"
      lang={language}
      className="flex items-center gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/30 dark:text-amber-200"
    >
      <WifiOff className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span className="flex-1">{t.message}</span>
      <button
        type="button"
        onClick={() => window.dispatchEvent(new Event(AUTH_RETRY_EVENT))}
        className="min-h-[44px] rounded-md px-3 font-medium underline hover:bg-amber-100 dark:hover:bg-amber-800/40"
      >
        {t.retry}
      </button>
    </div>
  );
}
